import React from "react";
var __jsx = React.createElement;
import { useLocation } from "react-router-dom";
import { apiUrl, apiUrlInternal, BUILD_VERSION, CDN_LINK, SELECTED_ENV, serverUrl, SHOW_DEBUG_INFO } from "@globalConfig";
import { onPushDataLayerNew } from "@/utils/events";
import stl from "./Aside.module.css";
import getMenuData from "./menuData";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { URL_SELL_TRADE_LANDING_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useSideMenuController, { dispatchSideMenuToggle as toggleMenu } from "@/_LayoutsRelated/layoutHooks/useSideMenuController";
var NewAside = function NewAside(_ref) {
  var switchLink = _ref.switchLink;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    createUrl2 = _useHelpers.createUrl2,
    navigateToHard = _useHelpers.navigateToHard;
  var _useTranslation = useTranslation(["web_aside_menu"]),
    t = _useTranslation.t;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useAuthActions = useAuthActions(),
    logout = _useAuthActions.logout;
  var showMenu = useSideMenuController();
  var sellTradeUrl = URL_SELL_TRADE_LANDING_v2;
  var location = useLocation();
  var menuDataFull = getMenuData(t, lang, {
    isLoggedIn: isLoggedIn,
    user: user,
    logout: logout
  }, {
    createUrl: createUrl,
    navigateToHard: navigateToHard
  }).filter(function (m) {
    return m.show;
  });
  return /*#__PURE__*/React.createElement("aside", {
    className: [stl.menu, showMenu ? stl.showMenu : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.menuContent
  }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("span", {
    onClick: toggleMenu
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 16,
    height: 16,
    src: CDN_LINK + "/assets/images/close_gry.svg",
    alt: "close"
  })), /*#__PURE__*/React.createElement("a", {
    href: createUrl(sellTradeUrl),
    onClick: function onClick() {
      trackEvents("sell_car_started", {
        referral_location: "side_menu",
        platform: getPlatformInfo(),
        version: "3"
      });
    }
  }, t("بدل/بيعنا سيارتك", {
    ns: "web_aside_menu"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.menuBody
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.logInSection
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.linksWrapper
  }, !isLoggedIn && /*#__PURE__*/React.createElement("a", {
    href: createUrl("/user/signup"),
    className: "".concat(stl.link, " ").concat(stl.withBorder)
  }, t("تسجيل الدخول/إنشاء حساب", {
    ns: "web_aside_menu"
  })), isLoggedIn && !(user !== null && user !== void 0 && user.is_dealer) && /*#__PURE__*/React.createElement("strong", {
    className: stl.userName
  }, t("أهلاً", {
    ns: "web_aside_menu"
  }), " ", user !== null && user !== void 0 && user.full_name ? user === null || user === void 0 ? void 0 : user.full_name : t("بك", {
    ns: "web_aside_menu"
  }), " ")), /*#__PURE__*/React.createElement("a", {
    className: stl.langSwitch,
    href: switchLink ? switchLink : createUrl2(location.pathname + location.search)
  }, /*#__PURE__*/React.createElement("span", null, lang !== "ar" ? "عربي" : "English"), /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/globe.svg",
    alt: "globe",
    width: 16,
    height: 16,
    loading: "lazy"
  }))), menuDataFull.map(function (mainMenu, idx) {
    return /*#__PURE__*/React.createElement("section", {
      key: mainMenu.sectionName,
      className: [stl.menuSection
      // idx === 0 ? "m-hide" : undefined,
      ].join(" ")
    }, /*#__PURE__*/React.createElement("strong", {
      className: stl.title
    }, t(mainMenu.sectionName, {
      ns: "web_aside_menu"
    })), /*#__PURE__*/React.createElement("ul", null, mainMenu.subLinks.filter(function (m) {
      return !m.hide;
    }).map(function (menuItem) {
      return /*#__PURE__*/React.createElement("li", {
        key: menuItem.link
      }, /*#__PURE__*/React.createElement("a", {
        id: menuItem.id || undefined,
        style: {
          cursor: 'pointer'
        },
        target: menuItem.isExternal ? "_blank" : undefined,
        href: menuItem.link,
        onClick: function onClick(e) {
          var _menuItem$linkFunc;
          (_menuItem$linkFunc = menuItem.linkFunc) === null || _menuItem$linkFunc === void 0 ? void 0 : _menuItem$linkFunc.call(menuItem, e);
        }
      }, /*#__PURE__*/React.createElement(ProgressiveImage, {
        waitUntilInteractive: true,
        width: 16,
        height: 16,
        style: {
          transform: menuItem.scale ? menuItem.scale : undefined
        },
        src: menuItem.imageBlue,
        alt: "icon"
      }), /*#__PURE__*/React.createElement(ProgressiveImage, {
        waitUntilInteractive: true,
        width: 16,
        height: 16,
        style: {
          transform: menuItem.scale ? menuItem.scale : undefined
        },
        src: menuItem.image,
        alt: "icon"
      }), /*#__PURE__*/React.createElement("span", null, menuItem.title)));
    })));
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.menuFooter
  }, /*#__PURE__*/React.createElement("strong", {
    className: "greenGrd"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 15,
    height: 17,
    src: CDN_LINK + "/assets/images/greenArmor.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, t("طرق دفع إلكترونية آمنة", {
    ns: "web_aside_menu"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: ["payment", stl.menuPayments].join(" ")
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Mada",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path7"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path8"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path9"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Visadark",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-mc",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-apple_pay",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Sadad",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-BankTransfer",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.socialMedia
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.title
  }, t("تابعنا لتصلك آخر عروض السيارات", {
    ns: "web_aside_menu"
  })), showMenu && /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/syarah.KSA",
    onClick: function onClick() {
      onPushDataLayerNew("syarah_events", "socialClicks", "facebook");
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 22,
    height: 22,
    src: CDN_LINK + "/assets/images/Facebook@1.svg",
    alt: "facebook icon"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/Syarah_ksa",
    onClick: function onClick() {
      onPushDataLayerNew("syarah_events", "socialClicks", "twitter");
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 22,
    height: 22,
    src: CDN_LINK + "/assets/images/Twitter@1.svg",
    alt: "twitter icon"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.instagram.com/Syarah_ksa/",
    onClick: function onClick() {
      onPushDataLayerNew("syarah_events", "socialClicks", "instagram");
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 22,
    height: 22,
    src: CDN_LINK + "/assets/images/Instagram@1.svg",
    alt: "instagram icon"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.snapchat.com/add/syarah_ksa",
    onClick: function onClick() {
      onPushDataLayerNew("syarah_events", "socialClicks", "snapchat");
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 22,
    height: 22,
    src: CDN_LINK + "/assets/images/Snapchat@1.svg",
    alt: "snapchat icon"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.youtube.com/channel/UCAceZ20JD3qef5OQSVc95Bw",
    onClick: function onClick() {
      onPushDataLayerNew("syarah_events", "socialClicks", "youtube");
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 22,
    height: 22,
    src: CDN_LINK + "/assets/images/Youtube@1.svg",
    alt: "youtube icon"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: stl.ftrLinks
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/terms-landing"),
    rel: "noopener noreferrer"
  }, t("الأحكام والشروط", {
    ns: "web_aside_menu"
  })), " ", "|", " ", /*#__PURE__*/React.createElement("a", {
    href: createUrl("/privacy-policy"),
    rel: "noopener noreferrer"
  }, t("سياسة الخصوصية", {
    ns: "web_aside_menu"
  }))), BUILD_VERSION && /*#__PURE__*/React.createElement("div", {
    className: stl.buildVer
  }, /*#__PURE__*/React.createElement("span", null, t("version", {
    ns: "web_aside_menu"
  }), ": ", /*#__PURE__*/React.createElement("strong", null, BUILD_VERSION))), SHOW_DEBUG_INFO && /*#__PURE__*/React.createElement("div", {
    className: stl.buildVer,
    style: {
      direction: "ltr"
    }
  }, /*#__PURE__*/React.createElement("p", null, "ENV: ", /*#__PURE__*/React.createElement("strong", null, SELECTED_ENV)), /*#__PURE__*/React.createElement("p", null, "API: ", /*#__PURE__*/React.createElement("strong", null, apiUrl)), /*#__PURE__*/React.createElement("p", null, "Internal API: ", /*#__PURE__*/React.createElement("strong", null, apiUrlInternal)), /*#__PURE__*/React.createElement("p", null, "Server URL: ", /*#__PURE__*/React.createElement("strong", null, serverUrl)))), /*#__PURE__*/React.createElement("div", {
    className: stl.sejelCont
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.sejelCont2
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, "container"].join(" ")
  }, /*#__PURE__*/React.createElement("p", null, t("شركة موقع سيارة للتجارة شركة موثقة لدى وزارة التجارة والاستثمار وبدعم من شركة علم, بسجل تجاري رقم 1010538980", {
    ns: "web_aside_menu"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.footerWithVat
  }, /*#__PURE__*/React.createElement("a", {
    className: stl.vatLink,
    href: CDN_LINK + "/assets/bundles/GAZT_VAT_Certificate.pdf",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 30,
    height: 38,
    src: CDN_LINK + "/assets/bundles/Vat.svg",
    alt: "vat icon"
  })), /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/bundles/saudi_elm.svg",
    alt: "saudi_elm icon",
    width: 262,
    height: 44,
    loading: "lazy"
  }))))))), /*#__PURE__*/React.createElement("div", {
    onClick: toggleMenu,
    className: stl.bgForMenu
  }));
};
export default NewAside;